define(function () {
    "use strict";

    // Covert a scientific numbers to a decimal number such as 1.0e-6 to 0.000001
    function scitodec(n) {
        n = String(n);
        var info = /([\d\.]+)e-(\d+)/i.exec(n);
        if (!info) {
            return n;
        }

        var num = info[1].replace(".", ""), numDecs = info[2] - 1;
        var output = "0.";
        for (var i = 0; i < numDecs; i++) {
            output += "0";
        }
        output += num;

        return output;
    }

    /**
     * Home-made Matrix class, for matrix computations and manipulations
     *
     * @param a
     * @param b
     * @param c
     * @param d
     * @param x
     * @param y
     * @constructor  create a new matrix
     */
    function Matrix(a, b, c, d, x, y){
        this.a = (a != null) ? a : 1;
        this.b = b || 0;
        this.c = c || 0;
        this.d = (d != null) ? d : 1;
        this.x = x || 0;
        this.y = y || 0;
    }

    Matrix.createFromString = function (matrix) {
        var m = new Matrix(),
            mVal = matrix && matrix.match(/\((.*?)\)/);

        if (mVal) {
            var mArray  = mVal[1].split(",");

            m.a = parseFloat(mArray[0]);
            m.b = parseFloat(mArray[1]);
            m.c = parseFloat(mArray[2]);
            m.d = parseFloat(mArray[3]);
            m.x = parseFloat(mArray[4]);
            m.y = parseFloat(mArray[5]);
        }
        return m;
    };

    Matrix.createFromDom = function(ele) {
        var st = window.getComputedStyle(ele, null),
            m = st.getPropertyValue("-webkit-transform") ||
            st.getPropertyValue("-moz-transform") ||
            st.getPropertyValue("-ms-transform") ||
            st.getPropertyValue("-o-transform") ||
            st.getPropertyValue("transform");

        return Matrix.createFromString(m);
    };

    Matrix.prototype = {

        copyFrom: function(m) {
            this.a = m.a;
            this.b = m.b;
            this.c = m.c;
            this.d = m.d;
            this.x = m.x;
            this.y = m.y;
        },

        identity: function() {
            this.a = 1;
            this.b = 0;
            this.c = 0;
            this.d = 1;
            this.x = 0;
            this.y = 0;
        },

        rotate: function(angle) {
            var u = Math.cos(angle),
                v = Math.sin(angle);

            var temp = this.a;
            this.a = u * this.a - v * this.b;
            this.b = v * temp + u * this.b;

            temp = this.c;
            this.c = u * this.c - v * this.d;
            this.d = v * temp + u * this.d;

            temp = this.x;
            this.x = u * this.x - v * this.y;
            this.y = v * temp + u * this.y;
        },

        rotateCenter: function(angle) {
            var u = Math.cos(angle),
                v = Math.sin(angle);

            var temp = this.a;
            this.a = u * this.a - v * this.b;
            this.b = v * temp + u * this.b;

            temp = this.c;
            this.c = u * this.c - v * this.d;
            this.d = v * temp + u * this.d;
        },

        translate: function(x, y) {
            this.x += x;
            this.y += y;
        },

        scale: function(x, y) {
            this.a *= x;
            this.b *= y;
            this.c *= x;
            this.d *= y;
            this.x *= x;
            this.y *= y;
        },

        scaleSize: function (x, y) {
            this.a *= x;
            this.b *= y;
            this.c *= x;
            this.d *= y;
        },

        concat: function(m) {
            var a = this.a * m.a,
                b = 0,
                c = 0,
                d = this.d * m.d,
                x = this.x * m.a + m.x,
                y = this.y * m.d + m.y;

            if (this.b !== 0 || this.c !== 0 || m.b !== 0 || m.c !== 0) {
                a += this.b * m.c;
                d += this.c * m.b;
                b += this.a * m.b + this.b * m.d;
                c += this.c * m.a + this.d * m.c;
                x += this.y * m.c;
                y += this.x * m.b;
            }

            this.a = a;
            this.b = b;
            this.c = c;
            this.d = d;
            this.x = x;
            this.y = y;
        },

        invert: function() {
            if (this.b === 0 && this.c === 0 && this.a !== 0 && this.d !== 0) {
                this.a = 1/this.a;
                this.d = 1/this.d;
                this.b = 0;
                this.c = 0;
                this.x = -this.a*this.x;
                this.y = -this.d*this.y;
            }else{
                var det = this.a*this.d - this.b*this.c;
                if (det === 0) {
                    this.identity();
                    return;
                }
                det = 1/det;

                var temp = this.a;
                this.a = this.d * det;
                this.b = -this.b * det;
                this.c = -this.c * det;
                this.d = temp * det;

                temp = this.y;
                this.y = -(this.b * this.x + this.d * this.y);
                this.x = -(this.a * this.x + this.c * temp);
            }
        },

        // if a value is represented as the format 1.0e-15, normalize to
        // float value to prevent inaccurate string representation.
        toString:  function() {
            var m = this.clone();
            m.a = scitodec(m.a);
            m.b = scitodec(m.b);
            m.c = scitodec(m.c);
            m.d = scitodec(m.d);

            return "matrix(" + m.a + "," + m.b + "," + m.c + "," + m.d + "," + m.x + "," + m.y + ")";
        },
        // if a value is represented as the format 1.0e-15, normalize to
        // float value to prevent inaccurate string representation.
        to3dString:  function() {
            var m = this.clone();
            m.a = scitodec(m.a);
            m.d = scitodec(m.d);

            return "scale3d("+ m.a+ ","+ m.d + ",1) translate(" + m.x+ "px," + m.y +"px)";
        },

        equals: function(m) {
            return this.a === m.a && this.b === m.b && this.c === m.c && this.d === m.d && this.x === m.x && this.y === m.y;
        },

        clone: function(){
            return new Matrix(this.a, this.b, this.c, this.d, this.x, this.y);
        },

        containsPoint: function(x, y, w, h) {
            // find mouse in local target space
            // and check within bounds of that area
            var inv = new Matrix(); // use pooled Matrix to reduce allocations
            inv.copyFrom(this);
            inv.invert();

            var tx = inv.x + inv.a * x + inv.c * y,
                ty = inv.y + inv.d * y + inv.b * x;

            // compare locations in non-transformed space (inverted)
            return tx >= 0 && tx <= w && ty >= 0 && ty <= h;
        },

        getRotationX: function() {
            return Math.atan2(this.b, this.a);
        },

        getRotationY: function() {
            return Math.atan2(this.c, this.d);
        },

        getRotation: function() {
            return Math.atan2(this.b, this.a) * (180/Math.PI);
        },

        getScaleX: function () {
            return Math.sqrt(this.a * this.a + this.b * this.b);
        },

        getScaleY: function () {
            return Math.sqrt(this.c * this.c + this.d * this.d);
        },

        getGlobalCoordByLocalCoord: function (x, y) {
            return {
                x: this.x + this.a * x + this.c * y,
                y: this.y + this.d * y + this.b * x
            };
        }
    };

    return Matrix;
});



// WEBPACK FOOTER //
// ./src/shared/vendor/Matrix.js